import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { defaultApprovalListFilters } from 'constants/defaultFilters';
import { TabsStatusFilter } from 'components/common/controls/TabsStatusFilter';
import DropdownSort from 'components/common/controls/DropdownSort';
import RefreshButton from 'components/common/controls/RefreshButton';

export default class ApprovalListControls extends Component {
    static propTypes = {
        route: PropTypes.object,
        counters: PropTypes.object,
        sort: PropTypes.object,

        sortFields: PropTypes.array,

        refreshMeta: PropTypes.object,
        handleRefresh: PropTypes.func,

        setSort: PropTypes.func,
        getList: PropTypes.func
    };

    render() {
        const { counters, sort, sortFields, route } = this.props;
        const { refreshMeta, handleRefresh, setSort } = this.props;

        return (
            <div>
                <TabsStatusFilter
                    counters={counters}
                    defaultFilters={defaultApprovalListFilters}
                    route={route}
                />
                <span className="icon-bar">
                    <DropdownSort
                        sort={ sort }
                        sortFields={ sortFields }
                        setSort={ setSort }
                    />
                    <RefreshButton refreshMeta={refreshMeta} handleRefresh={handleRefresh} />
                </span>
            </div>
        );
    }
}
